export default "__VITE_ASSET__DimAv8QG__"